<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>Please rate your worst pain in the past 24 hours (0 no pain; 10 worst pain imaginable):</p>
        <Radios name="pain-level" :entry="existingEntry" @store-number="storePainLevel" data="painLevel" amount="11" />
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your pain</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >Cancel</button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },
  methods: {
    storePainLevel(level) {
      this.form.painLevel = level;
    }
  },
  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        painLevel: this.existingEntry ? this.existingEntry.data.painLevel : 0
      }
    };
  }
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
